// extracted by mini-css-extract-plugin
module.exports = {"registerWrapper":"UserEdit_registerWrapper__udKRs"};